import { useCallback, useEffect, useRef } from "react";
import { auth } from "../firebase";
import { GoogleAuthProvider, signInWithCredential } from "firebase/auth";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { baseUrl, PopulateContext } from "../App";
import { useUsers } from "./Contexts/UsersContext"
import { useCourses } from "./Contexts/CoursesContext";
import { useEnrollee } from "./Contexts/EnrolleeContext";

declare global {
  interface Window {
    google: any;
  }
}

const OneTapLogin = () => {
  const navigate = useNavigate();
  const initialized = useRef(false);
  

  const { setUserContext, setUsersContext } = useUsers();
  const { setCoursesContext } = useCourses();
  const { setEnrolleeContext } = useEnrollee();

    const handleBackendAuth = useCallback(async (user: any) => {
    const email = user.email?.toLowerCase();
    const idToken = await user.getIdToken();

    try {
      const userResponse = await axios.post(
        `${baseUrl}/getusersbyfield`,
        { email },
        { headers: { Authorization: `Bearer ${idToken}` } }
      );

      const existingUser = userResponse?.data?.data?.[0];

      if (existingUser) {
      
        localStorage.setItem("UserId", existingUser.id);


        const [userData, allUsers, allCourses, allEnrollees] = await Promise.all([
          PopulateContext("User"),
          PopulateContext("Users"),
          PopulateContext("Courses"),
          PopulateContext("Enrollees"),
        ]);

        if (userData) setUserContext(userData);
        if (allUsers) setUsersContext(allUsers);
        if (allEnrollees) setEnrolleeContext(allEnrollees);
        if (allCourses) {
          const filtered = allCourses.filter((c: any) => !c.isArchive && !c.isDeleted);
          setCoursesContext(filtered);
        }
      
        navigate("/");
      }
    } catch (error) {
      console.error("Backend sync error:", error);
    }
  }, [navigate, setUserContext, setUsersContext, setCoursesContext, setEnrolleeContext]);


  useEffect(() => {
    const userId = localStorage.getItem("UserId");

   
    if (userId || !window.google || initialized.current) return;
     const handleCredentialResponse = async (response: any) => {
    try {
      const credential = GoogleAuthProvider.credential(response.credential);
      const result = await signInWithCredential(auth, credential);
      const user = result.user;

      await handleBackendAuth(user);
    } catch (error) {
      console.error("❌ One Tap login error:", error);
    }
  };
    initialized.current = true;
    const clientId = process.env.REACT_APP_GOOGLECLIENT_ID;

    window.google.accounts.id.initialize({
      client_id: clientId,
      callback: handleCredentialResponse,
      auto_select: false,
      cancel_on_tap_outside: true,
      context: "signin",
      use_fedcm_for_prompt: true,
    });

    window.google.accounts.id.prompt();
  }, [handleBackendAuth]);

 


  return null;
};

export default OneTapLogin;